import React from "react";
import {connect} from "react-redux";
import Footer from "./Footer";

const mapStateToProps = () => ({
    
})
export default connect(mapStateToProps)(Footer);
